let config = {
    apiUrl:process.env.REACT_APP_API_URL
  };

 export default Object.freeze(Object.assign({}, config));